import vtkPolyDataReader from './PolyDataReader';

export default {
  vtkPolyDataReader,
};
